import React from 'react'
import MileageSection from './MileageSection'
import InfoSection from './InfoSection'
import PropTypes from 'prop-types'
import { Button } from 'loyal-react'

import TermsOption from './TermsOption'

import yn from 'yn'

const Sidebar = ({
  partnerName,
  pointsValue,
  miles,
  loyaltyNumber,
  handleConfirmationModal,
  acceptTerms,
  acceptTermsEvent,
  showTermsEvent,
  currencyConfiguration,
  disabledFields,
  handleFormatValue,
  fidelityLabel,
  isLoadingRedemption
}) => (
  <div className='cart-side col-12 col-md-4 mt-3 mt-md-0 border-ui-3 radius bg-white px-0 py-0'>
    <div className='col-12 py-3 px-3 mx-0 border-color-ui-3 border-bottom'>
      <h3 className='color-title txt-font-body'>Resumo do resgate</h3>
    </div>
    <div className='cart-subtotal col-12 pb-3 mx-0'>
      <div className='row product-brand bg-ui-5 py-2  px-2  border-dotted-bottom border-color-ui-3'>
        <MileageSection
          mileage={partnerName}
          pointsValue={pointsValue}
          mileagePoints={handleFormatValue(miles || 0)}
          fidelityNumber={loyaltyNumber}
          currencyConfiguration={currencyConfiguration}
          fidelityLabel={fidelityLabel}
        />
      </div>
      <div className='row product-brand pt-3  px-2'>
        <InfoSection
          partnerName={partnerName}
          disabledFields={disabledFields}
        />
        {yn(process.env.REACT_APP_HAS_OPTIN_REGULATION) && <TermsOption
          acceptTerms={acceptTerms}
          acceptTermsEvent={acceptTermsEvent}
          disabledFields={disabledFields}
          showTermsEvent={showTermsEvent}
        /> }
      </div>
      <div className='cart-done row  px-2 pt-2 '>
        <div className='col-12 justify-content-center align-self-center'>
          <Button
            loading={isLoadingRedemption}
            className='btn-featured'
            disabled={validButton(
              partnerName,
              miles,
              loyaltyNumber,
              pointsValue,
              acceptTerms
            )}
            text='Transferir Pontos'
            onClick={handleConfirmationModal}
          />
        </div>
      </div>
    </div>
  </div>
)

const validButton = (
  partnerName,
  pointsValue,
  miles,
  loyaltyNumber,
  acceptTerms
) => {
  const result = !!(
    partnerName &&
    pointsValue &&
    miles &&
    loyaltyNumber &&
    (!yn(process.env.REACT_APP_HAS_OPTIN_REGULATION) || acceptTerms)
  )

  return !result ? 'disabled' : ''
}

Sidebar.propTypes = {
  partnerName: PropTypes.string,
  pointsValue: PropTypes.string,
  miles: PropTypes.number,
  loyaltyNumber: PropTypes.number,
  handleConfirmationModal: PropTypes.func,
  acceptTerms: PropTypes.bool,
  showTermsEvent: PropTypes.func,
  acceptTermsEvent: PropTypes.func,
  currencyConfiguration: PropTypes.object,
  disabledFields: PropTypes.bool,
  isLoadingRedemption: PropTypes.bool,
  handleFormatValue: PropTypes.func,
  fidelityLabel: PropTypes.string
}

export default Sidebar



// WEBPACK FOOTER //
// ./src/features/MileageRescue/Sidebar/Sidebar.js